import React from 'react';
import { Star } from 'lucide-react';

export const Stars = ({ value = 0, size = 16 }) => (
  <div className="flex items-center gap-0.5" aria-label={`${value} out of 5 stars`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        size={size}
        className={i < value ? 'text-alp-gold fill-alp-gold' : 'text-alp-line'}
      />
    ))}
  </div>
);
